"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PluginsApiImpl = void 0;
const tslib_1 = require("tslib");
const PluginsRedux = tslib_1.__importStar(require("../../Redux/ActionsReducers/PluginsRedux"));
const ApiBase_1 = require("./ApiBase");
class PluginsApiImpl extends ApiBase_1.ApiBase {
    getPluginsState() {
        return this.getAdaptableState().Plugins;
    }
    getPluginState(pluginId) {
        return this.getPluginsState()[pluginId];
    }
    registerPlugin(pluginId, initialPluginState) {
        this.setPluginState(pluginId, initialPluginState);
    }
    setPluginState(pluginId, newPluginState) {
        this.dispatchAction(PluginsRedux.PluginsSetPluginState(pluginId, newPluginState));
    }
    getPluginApi(pluginId) {
        try {
            const api = this.adaptable.getPluginProperty(pluginId, 'api');
            if (pluginId === 'ipushpull') {
                return api;
            }
            if (pluginId === 'glue42') {
                return api;
            }
            if (pluginId === 'glue42web') {
                return api;
            }
            if (pluginId === 'openfin') {
                return api;
            }
            if (pluginId === 'finsemble') {
                return api;
            }
            return api;
        }
        catch (ex) {
            return null;
        }
    }
    getipushpullPluginApi() {
        return this.getPluginApi('ipushpull');
    }
    getGlue42PluginApi() {
        return this.getPluginApi('glue42');
    }
    getGlue42WebPluginApi() {
        return this.getPluginApi('glue42web');
    }
    getOpenFinPluginApi() {
        return this.getPluginApi('openfin');
    }
    getFinsemblePluginApi() {
        return this.getPluginApi('finsemble');
    }
}
exports.PluginsApiImpl = PluginsApiImpl;
